import styled from '@emotion/styled';
import {colors, sizes} from "patient-ping-remedy/packages/theme";
import {SmallTypography} from "patient-ping-remedy/packages/typography";

export const Wrapper = styled.div`
  display: flex;
  gap: ${sizes.large};
`;

export const DemographicsWrapper = styled.div`
  width: 100%;
`;

export const HistoryRow = styled.div`
  display: flex;
  margin-bottom: ${sizes.medium};
`;

export const PhoneHistoryTableContainer = styled.div`
  width: 45%;
  margin-right: 96px;
`;

export const InsuranceHistoryTableContainer = styled.div`
  width: 45%;
`;

export const TableContainer = styled.div`
  width: 45%;
  margin-right: 96px;
`;

export const TableContainerRight = styled.div`
  width: 45%;
`;

export const HistoryTableLabel = styled(SmallTypography)`
  display: flex;
  font-size: 1.4rem;
  line-height: 1.8rem;
  font-weight:400;
  color: ${colors.gray5};
  text-align: left;
  margin-bottom: 0.8rem;
`;

export const HistoryTable = styled.table`
    border-collapse: collapse;  

  tr th:not(:first-of-type) {
    padding: 0 0.8rem;
  }

  tr td:not(:first-of-type) {
    padding: 0.4rem 1.6rem 0.4rem 0.8rem;
  }

  th {
    border-bottom: 1px solid ${colors.gray2};
  }

  tbody tr td  {
    font-weight: 400;
    font-size: 1.6rem;
    align-content: start;
    text-align: left;
    line-height: 2rem;
    color: ${colors.charcoal};
    padding: 0.4rem 1.6rem 0.4rem 0;
  }

  thead tr th  {
    font-weight: 400;
    font-size: 1.6rem;
    text-align: left;
    line-height: 2rem;
    color: ${colors.charcoal};
    padding: 0.4rem 0.8rem 0.4rem 0;
  }
`;

export const DemographicsRow = styled.div`
  display: flex;
  gap: ${sizes.large};
  flex-wrap: nowrap;
  margin-bottom: ${sizes.medium};
`;

export const DemographicColumn = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    * {
        margin: 0 !important;
        padding: 0 !important;
    }
    
    br {
        display: block;
        height: 8px;
        content: "";
        margin: 0;
        padding: 0;
    }
`;

export const StyledValue = styled.span`
  font-weight: 400;
  font-size: 1.6rem;
`;
